import { COLUMN_ACCESS_GROUP, COLUMN_COMPANY, COLUMN_DAYS, COLUMN_DEPARTMENT, COLUMN_DISPLAY_NAME, COLUMN_DOOR, COLUMN_DURATION, COLUMN_FIRST_NAME, COLUMN_LAST_NAME, COLUMN_SECOND_NAME, COLUMN_SITE, COLUMN_START_TIME, COLUMN_SUFFIX, COLUMN_TIME_PATTERN, COLUMN_TITLE, COLUMN_UNIQUE_IDENTIFIER } from "../../constants/column-types";
import { FILTER_ACCESS_GROUP, FILTER_ACCESS_TIME_PATTERN, FILTER_COMPANIES, FILTER_DEPARTMENTS, FILTER_DOORS, FILTER_SITES, FILTER_TAGHOLDERS } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const DoorAccessReportColumns : TableColumn[] = [
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 0,
        sortByName: "mstTitle",
        sortDirection: "asc",
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE,
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME,
        lookupName: "mstDisplayname",
        searchOnName: "masterId",
        filterId: FILTER_TAGHOLDERS,
        settingDataName: 'master',
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 2,
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 3,
        sortByName: "mstMiddlename",
        sortDirection: "asc",
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME,
    },
    {
        heading: "Unique Identifier",
        accessor: "uid",
        isNumeric: true,
        id: 4,
        sortByName: "mstIdnumber",
        sortDirection: "asc",
        active: true,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 5,
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 6,
        active: true,
        searchOnName: "departmentId",
        lookupName: "department",
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: 'department'
    },
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 7,
        searchOnName: "companyId",
        lookupName: "company",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: 'company'
    },
    {
        heading: "Door",
        accessor: "door",
        isNumeric: false,
        id: 8,
        searchOnName: "locationId",
        lookupName: "locationId",
        active: false,
        translationKey: "door",
        columnId: COLUMN_DOOR,
        filterId: FILTER_DOORS,
        settingDataName: 'location',
        isFilterOnlyColumn: true
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 9,
        searchOnName: "siteId",
        lookupName: "site",
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: 'site'
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        isNumeric: false,
        id: 10,
        sortByName: "mstSuffix",
        active: false,
        translationKey: "suffix",
        columnId: COLUMN_SUFFIX,
    },
    {
        heading: "Access Group",
        accessor: "accessGroup",
        isNumeric: false,
        id: 11,
        searchOnName: "accessGroupId",
        lookupName: "accessGroupId",
        active: false,
        translationKey: "accessGroup",
        columnId: COLUMN_ACCESS_GROUP,
        filterId: FILTER_ACCESS_GROUP,
        settingDataName: "accessGroup",
        isFilterOnlyColumn: true
    },
    {
        heading: "Time Pattern",
        accessor: "timePattern",
        isNumeric: false,
        id: 12,
        searchOnName: "accessTimePatternId",
        lookupName: "accessTimePatternId",
        active: false,
        translationKey: "accessTimePattern",
        columnId: COLUMN_TIME_PATTERN,
        filterId: FILTER_ACCESS_TIME_PATTERN,
        settingDataName: "accessTimePattern",
        isFilterOnlyColumn: true
    },
];

export const DoorAccessReportChildColumns: TableColumn[] = [
    {
        heading: "Access Group",
        accessor: "accessGroup",
        isNumeric: false,
        id: 20,
        active: true,
        translationKey: "accessGroup",
        columnId: COLUMN_ACCESS_GROUP,
    },
    {
        heading: "Time Pattern",
        accessor: "timePattern",
        isNumeric: false,
        id: 21,
        active: true,
        translationKey: "timePattern",
        columnId: COLUMN_TIME_PATTERN,
    },
    {
        heading: "Start Time",
        accessor: "startTime",
        isNumeric: false,
        id: 22,
        active: true,
        translationKey: "startTime",
        columnId: COLUMN_START_TIME,
    },
    {
        heading: "Duration",
        accessor: "duration",
        isNumeric: false,
        id: 23,
        active: true,
        translationKey: "duration",
        columnId: COLUMN_DURATION,
    },
    {
        heading: "Days",
        accessor: "days",
        isNumeric: false,
        id: 24,
        active: true,
        translationKey: "days",
        columnId: COLUMN_DAYS,
    },
];

export default DoorAccessReportColumns;
